module.exports = __webpack_public_path__ + "static/icons/icon-map--white-4e26389a6b2880b32896a038f757cac9.svg";